import {StyledBaseProps} from "@betrue/shared/interfaces";
import {ProfileAvatarEditorProps} from "./profile-avatar-editor";
import styled from "styled-components";
import Dropzone from 'react-dropzone'
import AvatarEditor from 'react-avatar-editor'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, Grid,
  Slider,
  Typography
} from "@material-ui/core";
import {useCallback, useRef, useState} from "react";
import {useDropzone} from "react-dropzone";
import * as React from "react";

export interface ProfileAvatarEditorViewProps extends StyledBaseProps, ProfileAvatarEditorProps {

  onSubmit: (base64Image: string) => void
  currentImage: string,
  modalOpen: boolean,
  onClose: () => void
}

export const ProfileAvatarEditorView = styled((props: ProfileAvatarEditorViewProps) => {

  const [image, setImage] = useState(props.currentImage)
  const [zoom, setZoom] = useState(1)

  const onDrop = useCallback(dropped => {
    setImage(dropped[0])
    // Do something with the files
  }, [])

  const imageAvatar = useRef<AvatarEditor>()

  const save = useCallback(() => {
    if (image) {
      props.onSubmit(imageAvatar.current.getImageScaledToCanvas().toDataURL())

    } else {
      props.onSubmit('')
    }
  }, [image,props.modalOpen])

  const clear = useCallback(() => {
    setImage('')
  }, [])

  const handleZoom = useCallback((event, newZoom) => {
    setZoom(newZoom)
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
  return (<div className={props.className}>
    <Dialog
      disableAutoFocus={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
      open={props.modalOpen}
      disablePortal={true}
      onClose={() => props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">

      <DialogTitle id="customized-dialog-title">
        {props.dialogTitle ? props.dialogTitle : 'Dites-nous Cheeeeese 🤳'}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {props.dialogSubtitle ? props.dialogSubtitle : 'Votre plus beau sourire en glisser-déposer ou cliquer' +
            ' chercher'}
        </DialogContentText>
        <Grid
          container
          alignContent={"center"}
          justifyContent={"center"}
          alignItems={"center"}
          direction={"column"}>
          <Dropzone
            onDrop={onDrop}
            noClick={!!image}
            noKeyboard={!!image}
            accept={['image/png', 'image/jpeg']}
          >
            {({getRootProps, getInputProps}) => (
              <div {...getRootProps()}>
                {image ? (<><AvatarEditor width={250}
                                          height={250}
                                          ref={imageAvatar}
                                          scale={zoom}
                                          borderRadius={250/2}
                                          image={image}/>
                  <Typography gutterBottom>
                    Zoom
                  </Typography>
                  <Slider value={zoom} onChange={handleZoom} min={1 / 2} max={2} step={0.00000001}
                          aria-labelledby="continuous-slider"/></>) : (<div>
                  <div className={'bt-drop-zone'}>
                    <p>{props.dropZoneLabel ? props.dropZoneLabel : 'Déposer Votre fichier ou cliquer ici'}</p>
                  </div>
                </div>)}

                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>

        </Grid>


      </DialogContent>
      <DialogActions>

        <Button onClick={props.onClose} color="primary">
          {props.dialogCancel ? props.dialogCancel : 'Annuler'}
        </Button>
        <Button onClick={clear} color="secondary">
          {props.dialogReset ? props.dialogReset : 'Effacer'}
        </Button>
        <Button autoFocus onClick={save} color="primary">
          {props.dialogSave ? props.dialogSave : 'Valider'}
        </Button>
      </DialogActions>
    </Dialog>

  </div>)

})`

  & .bt-drop-zone {
    flex: 1;
    width: 250px;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: #eeeeee;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
  }

  & .bt-drop-zone:focus {
    border-color: #2196f3;
  }

`

